import Vue from 'vue';
import store from '@/store';
Vue.filter('currency', (amount) => {
  const decimalType = store.state.auth.currency.decimalType;
  const decimalCount = decimalType ? 2 : 0;
  const decimal = ".";
  const thousands = ",";
  const symbol = store.state.auth.currency.symbol;
  try {
    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(amount = Math.abs(Number(amount) || 0)
      .toFixed(decimalCount))
      .toString();
    let j = (i.length > 3) ? i.length % 3 : 0;

    return negativeSign + symbol + (j ? i.substr(0, j) + thousands : '') + i.substr(j)
      .replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i)
      .toFixed(decimalCount)
      .slice(2) : "");
  } catch (e) {
    console.log(e)
  }
  return amount;
})

Vue.filter('decimal', (value) => {
  const decimalType = store.state.auth.currency.decimalType;
  if(!decimalType) {
    return value;
  }
  return +(Math.round(value + "e+2")  + "e-2");
});

Vue.filter('decimalNumber', (value) => {
  return +(Math.round(value + "e+3")  + "e-3");
});
